// Humanizer.js
export function humanizeText(inputText) {
    const paragraphs = inputText.split('\n');
    let humanizedText = '';

    for (const paragraph of paragraphs) {
        let humanizedParagraph = paragraph;

        // Randomly remove some commas
        humanizedParagraph = humanizedParagraph.replace(/,/g, (match) => Math.random() < 0.6 ? '' : match);

        // Add or remove spaces around punctuation (.,?!)
        humanizedParagraph = humanizedParagraph.replace(/(\s+)?([,.?!])(\s+)?/g, (match, p1, p2, p3) => {
            const spaceBefore = Math.random() < 0.3 ? ' ' : '';
            const spaceAfter = Math.random() < 0.7 ? ' ' : '';
            return spaceBefore + p2 + spaceAfter;
        });

        // Occasionally swap adjacent words
        humanizedParagraph = humanizedParagraph.replace(/(\b\w+\b)\s+(\b\w+\b)/g, (match, p1, p2) => Math.random() < 0.05 ? p2 + ' ' + p1 : match);

        humanizedText += humanizedParagraph + '\n';
    }

    return humanizedText.trim();
}
